// DEPRECATED. Please import from constants/FeatureTypes.
export * from '@disco/constants/FeatureTypes'

/** Lite plan identifier for 2020 pricing structure. */
export const LITE_ID = '2020-lite'

/** Plus plan identifier for 2020 pricing structure. */
export const PLUS_ID = '2020-plus'

/** Pro plan identifier for 2020 pricing structure. */
export const PRO_ID = '2020-pro'

/** Enterprise plan identifier for 2020 pricing structure. */
export const ENTERPRISE_ID = '2020-enterprise'

/** Artist plan identifier introduced in 2023. */
export const ARTIST_ID = '2023-artist'

/**
 * Union type representing all available plan identifiers.
 *
 * Used throughout the application to identify different subscription
 * plans and their associated features and pricing.
 *
 * @example
 * ```typescript
 * const currentPlan: PlanId = '2020-pro'
 *
 * function checkPlanFeatures(planId: PlanId) {
 *   switch (planId) {
 *     case LITE_ID:
 *       return basicFeatures
 *     case PRO_ID:
 *       return advancedFeatures
 *     // ...
 *   }
 * }
 * ```
 */
export type PlanId =
  | '2020-lite'
  | '2020-plus'
  | '2020-pro'
  | '2020-enterprise'
  | '2023-artist'
